import {AgGridReact} from "ag-grid-react";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../../utils/ag-grid-columns-utils.js";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import React, {memo, useMemo} from "react";
import {useQuery} from "@tanstack/react-query";
import capturePlacesService from "../../../../../../services/web/capture-places-service.js";
import Loader from "../../../../../../components/template/loader.jsx";
import routeService from "../../../../../../services/web/route-service.js";
import {useFormContext} from "react-hook-form";

const typeSelected = {
  capturePlace: {
    service: capturePlacesService.getList,
    queryKey: "capturePlace",
  },
  route: {
    service: routeService.getList,
    queryKey: "route",
  }
}
const SelectItemTable = ({gridRef, setSelectedItem, columnDefs, type}) => {
  const {watch} = useFormContext();
  const mobile = watch("capturePlace.mobile");
  const capturePlaceCode = watch("capturePlace.code");
  const {data, isLoading} = useQuery({
    queryFn: () => typeSelected[type].service(),
    queryKey: [typeSelected[type]]
  })

  const tableData = useMemo(() => {
    if(type !== "capturePlace") return data ?? [];
    if(mobile) return (data ?? []).filter(item => item.mobile);
    if(capturePlaceCode) return (data ?? []).filter(item => !item.mobile);
    return data ?? [];
  }, [capturePlaceCode, data, mobile, type]);

  const onRowClicked = ({data}) => {
    setSelectedItem(data);
  }

  return(
    <>
      {isLoading && <Loader/>}
      <div className="h-full aggrid-row-pointer">
        <AgGridReact
          onGridReady={(params) => {
            gridRef.current = params.api;
          }}
          tooltipShowDelay={400}
          tooltipShowMode='whenTruncated'
          rowData={tableData}
          columnDefs={columnDefs}
          defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
          animateRows={false}
          rowSelection={{
            mode: 'singleRow',
            checkboxes: false,
            headerCheckbox: false,
            enableClickSelection: true
          }}
          onRowClicked={onRowClicked}
          onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
          suppressCellFocus={true}
          gridOptions={{localeText: aggridUtils.localization()}}
          theme={aggridUtils.generalTheme()}
        />
      </div>
    </>
  )
}

export default memo(SelectItemTable);